import React from 'react';
import Modal from '../../../components/Modal';

const AccionSolicitud = props => (
  <Modal title={`${props.actionName} solicitud`} idModal='accion-solicitud' isOpen closeModal={props.closeModal} modalSize='modal-dialog'>
    <p>{`¿Deseas ${props.actionName.toLowerCase()} la solicitud de autorizacion excepcional?`}</p>
    <button className='btn btn-default' onClick={props.closeModal}>Cancelar</button>
    <button className='btn btn-primary pull-right' onClick={props.action}>{props.actionName}</button>
  </Modal>
);

export default AccionSolicitud;



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitudExcepcional/AccionSolicitud.js